<template>
  <div>
    <ModelViewer ref="modelV" :modelPath="filePath"></ModelViewer>
  </div>
</template>

<script>
  import ModelViewer from '@/components/ModelViewer'
  export default {
    components: {
      ModelViewer,
    },
    data() {
      return {
        filePath: '',
      }
    },
    created() {
      this.filePath = this.$route.query.svfUrl
    },
  }
</script>

<style></style>
